import axios from "axios";
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";

const store = configureStore({
  reducer: authReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const initializeStoreSubscriber = (): void => {
  store.subscribe(() => {
    const latestState = store.getState();

    if (latestState.isLogin) {
      axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem("token")}`;
    }
  });
};

export default store;
